<template>
  <Dialog
    titulo="Cancelar Ajustes no Carrinho"
    texto="Você realmente deseja cancelar seu ajuste? Se você cancelar, voltará para o carrinho sem que o ajuste seja aplicado."
    texto_btn_secundario="Voltar"
    texto_btn_principal="Cancelar Ajuste"
    @click:btn-principal="$emit('click:btn-principa', {})"
  >
    <template #ativador="{ callback }">
      <slot name="ativador" :callback="() => cancelar(callback)">
        <v-btn
          class="text-transform-none font-weight-regular"
          outlined
          color="#013254"
          @click="() => cancelar(callback)"
        >
          Cancelar
        </v-btn>
      </slot>
    </template>
  </Dialog>
</template>

<script setup>
import Dialog from "@/components/compra/ProdutosGerais/Carrinho/Meta/Dialog.vue";

const props = defineProps({
  parametros: Object,
});

const emit = defineEmits(['click:btn-principa']);

function cancelar(callback) {
  if (Number(props.parametros.valor_desejado) > 0) {
    callback()
  } else {
    emit('click:btn-principa', {})
  }
}
</script>

<style scoped>

</style>
